<script lang="ts">
	import Accordion from '../parts/faq/accordion.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			question: string;
			answer: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<Accordion title={content.question}>
		<div class="faq-item pt-4 text-[16px]/[140%] lg:pt-5">
			<SbRichtext text={content.answer} />
		</div>
	</Accordion>
</div>

<style lang="scss">
	.faq-item {
		:global(ul li) {
			list-style-type: disc;
			list-style-position: outside;
			margin-left: 16px;
			margin-top: 8px;
			margin-bottom: 8px;
		}

		:global(ul li p) {
			display: inline;
		}
	}
</style>
